import * as React from "react";
import type { SVGProps } from "react";
const SvgStars = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m14.824 2.4 1.83 4.946 4.946 1.83-4.946 1.83-1.83 4.947-1.83-4.946-4.947-1.83 4.946-1.83zM6.353 13.694l1.599 2.354 2.354 1.6-2.354 1.598L6.353 21.6l-1.599-2.354L2.4 17.647l2.354-1.599z"
    />
  </svg>
);
export default SvgStars;
